import React from 'react';
import styled from 'styled-components';
import { PLACE_DU_DESIGN_OPTIONS } from '../sdeConstants';

const StepContainer = styled.div`max-width: 700px; margin: 0 auto;`;
const StepTitle = styled.h2`font-size: 1.5rem; font-weight: 600; color: #1F2937; margin-bottom: 0.5rem;`;
const StepSubtitle = styled.p`color: #6B7280; margin-bottom: 1.25rem; font-size: 0.95rem;`;
const FormGroup = styled.div`margin-bottom: 1rem;`;
const Label = styled.label`
  display: block; font-size: 0.95rem; font-weight: 500; color: #374151; margin-bottom: 0.4rem;
  ${props => props.required && `&::after { content: ' *'; color: #EF4444; }`}
`;
const Hint = styled.p`font-size: 0.85rem; color: #9CA3AF; margin: 0.25rem 0 0.5rem;`;
const Textarea = styled.textarea`
  width: 100%; padding: 0.75rem 1rem; font-size: 0.95rem; border: 2px solid #E5E7EB; border-radius: 8px;
  background: #F9FAFB; min-height: 100px; resize: vertical;
  &:focus { outline: none; border-color: #2563EB; background: white; }
`;

const SectionCard = styled.div`
  background: #F0F4FF; border: 1px solid #C7D2FE; border-radius: 8px; padding: 10px 14px; margin-bottom: 1rem;
`;
const SectionTitle = styled.div`
  font-size: 0.9rem; font-weight: 600; color: #374151; margin-bottom: 6px;
  ${props => props.required && `&::after { content: ' *'; color: #EF4444; }`}
`;
const CheckboxGroup = styled.div`
  display: flex; flex-direction: column; gap: 2px;
`;
const CheckboxLabel = styled.label`
  display: flex; align-items: flex-start; gap: 8px; font-size: 0.85rem; color: #374151;
  cursor: pointer; padding: 2px 6px; border-radius: 4px; transition: background 0.15s;
  margin: 0; line-height: 1.2;
  &:hover { background: #E0E7FF; }
  input[type="checkbox"] { width: 16px; height: 16px; accent-color: #2563EB; cursor: pointer; margin: 2px 0 0; flex-shrink: 0; }
`;

const PopAStep2_Needs = ({ data, updateData, lang = 'fr' }) => {
  const metadata = data.metadata || {};
  const placeList = metadata.place_du_design || [];

  const updateMeta = (field, value) => {
    updateData({ metadata: { ...data.metadata, [field]: value } });
  };

  const handlePlaceToggle = (value) => {
    const next = placeList.includes(value)
      ? placeList.filter(v => v !== value)
      : [...placeList, value];
    updateMeta('place_du_design', next);
  };

  return (
    <StepContainer>
      <StepTitle>{lang === 'fr' ? 'Votre offre' : 'Your Offering'}</StepTitle>
      <StepSubtitle>
        {lang === 'fr'
          ? 'Décrivez votre offre'
          : 'Describe your offering'}
      </StepSubtitle>

      <FormGroup>
        <Label required>{lang === 'fr' ? 'Offre / Typologie de mobiliers' : 'Offering / Furniture typology'}</Label>
        <Hint>
          {lang === 'fr'
            ? 'Décrivez votre offre, les typologies de mobilier que vous produisez ou éditez'
            : 'Describe your offering, the furniture typologies you produce or publish'}
        </Hint>
        <Textarea
          value={metadata.offre || ''}
          onChange={e => updateMeta('offre', e.target.value)}
          placeholder={lang === 'fr'
            ? 'Ex: Mobilier de bureau, assises, luminaires, mobilier outdoor...'
            : 'E.g., Office furniture, seating, lighting, outdoor furniture...'}
        />
      </FormGroup>

      <FormGroup>
        <Label required>{lang === 'fr' ? 'Savoir-faire, matériaux et techniques' : 'Know-how, materials and techniques'}</Label>
        <Hint>
          {lang === 'fr'
            ? 'Décrivez vos savoir-faire, les matériaux et techniques que vous maîtrisez'
            : 'Describe your expertise, materials and techniques you master'}
        </Hint>
        <Textarea
          value={metadata.savoir_faire || ''}
          onChange={e => updateMeta('savoir_faire', e.target.value)}
          placeholder={lang === 'fr'
            ? 'Ex: Travail du bois massif, tapisserie, métal, injection plastique...'
            : 'E.g., Solid wood work, upholstery, metal, plastic injection...'}
        />
      </FormGroup>

      <SectionCard>
        <SectionTitle required>
          {lang === 'fr' ? 'Place du design dans votre entreprise' : 'Role of design in your company'}
        </SectionTitle>
        <Hint>
          {lang === 'fr'
            ? 'Cochez au moins une option'
            : 'Check at least one option'}
        </Hint>
        <CheckboxGroup>
          {PLACE_DU_DESIGN_OPTIONS.map(opt => (
            <CheckboxLabel key={opt.value}>
              <input
                type="checkbox"
                checked={placeList.includes(opt.value)}
                onChange={() => handlePlaceToggle(opt.value)}
              />
              {lang === 'fr' ? opt.label_fr : opt.label_en}
            </CheckboxLabel>
          ))}
        </CheckboxGroup>
      </SectionCard>
    </StepContainer>
  );
};

export default PopAStep2_Needs;
